// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__2Upxf","info":"style_info__1QlSK","title":"style_title__3LLnB","subtitle":"style_subtitle__3FZu7"};